import type { RouteRecordRaw } from "vue-router";
import { organizationRoutes } from "@/router/organization_settings_routes";

export const profileRoute: RouteRecordRaw = {
  path: "profile",
  name: "profile",
  meta: {
    activityArea: "settings",
    title: "Profile Settings",
    text: "Profile Settings",
    description: "Edit your user profile settings",
    icon: "user",
    helpDeskPath: "settings",
    requiresAuth: true,
    contentWidth: "wide",
    breadcrumb: false,
  },
  component: () => import("@/views/UserSettings/UserSettingsBase.vue"),
};

export const settingsRoute: RouteRecordRaw = {
  path: "/settings",
  name: "settings",
  redirect: { name: "general" },
  meta: {
    activityArea: "settings",
    title: "Settings",
    text: "Settings",
    description: "Edit organization settings",
    icon: "settings",
    helpDeskPath: "settings",
    requiresAuth: true,
    breadcrumb: { label: "Settings", to: { name: "general" } },
    // Declared on the shell so every settings tab inherits it: `route.meta` is
    // the merged matched chain, and without this the whole subtree fell through
    // to the root `base` route's "standard", which centres it in a max-w-7xl.
    // "wide" rather than "full-bleed" because these views render forms and
    // tables straight into the slot and rely on the frame for their gutters.
    contentWidth: "wide",
  },
  component: () =>
    import("@/views/OrganizationSettings/OrganizationOverview.vue"),
  children: [...organizationRoutes, profileRoute],
};

export const setupProgressRoute: RouteRecordRaw = {
  path: "/profile/progress",
  name: "setup-progress",
  meta: {
    activityArea: "settings",
    title: "Get more from Fyr",
    text: "Get more from Fyr",
    description: "Your user level and what to set up or try next",
    icon: "rocket-launch",
    requiresAuth: true,
    contentWidth: "wide",
    breadcrumb: false,
  },
  component: () => import("@/views/UserSettings/SetupProgressPage.vue"),
};

export const createOrganizationRoute: RouteRecordRaw = {
  path: "/create-organization",
  name: "create-organization",
  meta: {
    activityArea: null,
    title: "Create Organization",
    text: "Create a new organization",
    description: "Create a new organization, and invite users to it",
    icon: "plus",
    requiredPermissions: ["canOnboard"],
    helpDeskPath: "settings",
    requiresAuth: true,
    breadcrumb: false,
  },
  component: () =>
    import("@/views/OrganizationSettings/CreateOrganization.vue"),
};

export const agencyHubRoute: RouteRecordRaw = {
  path: "/hub",
  name: "hub",
  meta: {
    activityArea: "agency_hub",
    title: "Hub",
    text: "Hub",
    description: "Overview of your organizations",
    icon: "users",
    requiredPermissions: ["isAgency"],
    requiresAuth: true,
    contentWidth: "full-bleed",
    breadcrumb: false,
  },
  component: () => import("@/views/Hub/HubView.vue"),
};

export const settingRoutes: RouteRecordRaw[] = [
  settingsRoute,
  agencyHubRoute,
  createOrganizationRoute,
];
